import { jsx } from "react/jsx-runtime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { validateTidalLicense } from "../../base/index.js";
function ErrorOutline(props) {
  return /* @__PURE__ */ jsx(
    ErrorOutlineIcon,
    {
      "data-testid": "ErrorOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ErrorOutline",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
ErrorOutline.tidalIconMeta = {
  categories: "cancel,informative",
  name: "ErrorOutline"
};
validateTidalLicense();
export {
  ErrorOutline
};
//# sourceMappingURL=ErrorOutline.js.map
